import { render } from "./upload-text.vue?vue&type=template&id=0ce73299"
const script = {}

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__